/**
 * Created by JIocb on 13.05.2017.
 */
namespace Factive.Game {
        export enum PanelName
        {
            DialogColorBonus,
            Help,
            Achievement,
            GameEnd,
            AreYouSureQuit,
            Settings
        }

}


// WEBPACK FOOTER //
// src/typescript/Game/Engine/Panel/PanelName.ts